<template>

	<div
		class="app-sidebar-dev"
	>

		<div
			v-for="link in links"
			:key="`dev-link-${link.name}`"
			class="dev-link"
		>
			<!-- FIXME: @kovalevadim companyId брать из стора -->
			<ao-btn
				class="left-sidebar-btn"
				variant="text"
				block
				:to="{ name: link.name }"
			>
				<!-- {{ link.meta.titleTranslationKey ? $t(link.meta.titleTranslationKey) : link.meta.title }} -->
				{{ link.path }}
			</ao-btn>
		</div>

	</div>

</template>

<script>
import { DEVELOPERS_PAGES } from '@/config/router/routerConfig'

export default {

	name: 'SidebarDev',

	components: {},

	props: {},

	emits: {},

	data: () => ({

		//data

	}),

	computed: {

		links() {
			return DEVELOPERS_PAGES
		},

	},

	created() {},

	methods: {

		// getTabRouteNameFromModuleRouteName(routeName) {
		// 	let module = this.$router.getRoutes().find((item) => (item.name === routeName))
		// 	if (!module) {
		// 		return routeName
		// 	}
		// 	return module.meta.defaultTabView ? module.meta.defaultTabView : module.name
		// },

	},

}
</script>

<style lang="scss">

</style>
